export const ATTRIBUTION_READY_EVENT = 'AttributionReady';
export const HCP_BUSINESS_ID = '671073f1-02b3-400d-b5cd-e09d6914a208';
